/*jshint esversion: 6 */

import React, { Component } from 'react';
import * as strFuncs from "./stringFuncs.js";
import * as pagesSorter from './sortObjects.js';

export function getParagraphTemplate(paragaphObj, _templates){
    if(_templates){
        if(_templates.length){
            let templates = _templates.slice();//this.props.templates.slice();
            paragaphObj.displayTemplate = templates.filter(dp => dp._id === paragaphObj.display_type);    
        }
    }
  }


  export function getParagraphManuses(paragaphObj, _manuses){//manusObjects
    let paragraphManusObjects = [];
    if(_manuses){
        if(_manuses.length){
            let allManusObjects = _manuses.slice();//this.props.manuses.slice();
            let manusIdArray = paragaphObj.manuses.slice();
            if(manusIdArray.length){
            let manusOrders = paragaphObj.manus_orders.slice();
            let manusObjects = allManusObjects.filter(manusO => manusIdArray.includes(manusO._id));
            paragraphManusObjects = pagesSorter.sortManusObjects(manusOrders, manusObjects);
            // //console.log('manusIdArray', manusIdArray);
            // allManusObjects.forEach(parManus => {
            //   if(manusIdArray.includes(parManus._id)){
            //     paragraphManusObjects.push(parManus);
            //   }
            // })
            }
        }
    }
    paragaphObj.manusObjects = paragraphManusObjects;    
  }

  export function  getPageParagraphs(pageObjects, _paragraphs, _manuses, _templates){
    console.log('getPageParagraphs(pageObjects)',pageObjects);
    if(pageObjects)
    pageObjects.forEach(pageObj => {
        console.log('getPageParagraphs(pageObjects) pageObject,paragraphObjects: ',pageObj.pagetitle,  pageObj.paragraphObjects);
        let pageParagraphObjects = [];
        let sortedNumbersArray=[];
        let pageParArr = pageObj.paragraphs;
        if(pageParArr){
            if(pageParArr.length){
                let paragraphs = _paragraphs.slice();//this.props.paragraphs.slice();
                // if(pageParArr.length === 1){
                //     console.log('getPageParagraphs par 1 : pageParArr', pageParArr);
                //     pageParagraphObjects = paragraphs.filter(pr => pageParArr.includes(pr._id));
                //     console.log('getPageParagraphs paragraphs 1 : paragraphs', paragraphs);
                //     console.log('getPageParagraphs paragraphs 1 : PAGE PARGRAPHS', pageParagraphObjects);
                // }
                // else{
                    paragraphs.forEach(par => {
                        if(pageParArr.includes(par._id)){
                            //for sorting
                            /* orders :["5abcd5a477fce92adc405485:1", "5abca81857929f125e3ef31a:1"] */
                            //paragraphs that refer to this page object
                            let orders = par.orders.filter(o => o.includes(pageObj._id));
                            orders.map(orderPair => {
                            let orderPairArray = orderPair.split(':');
                            if(orderPairArray.length === 2){
                                let orderNr = parseInt(orderPairArray[1], 10);
                                sortedNumbersArray.push({order:orderNr , paragraph:par});
                            }
                            });//orders.map
                            
                            if(sortedNumbersArray.length){
                            //get other paragrpha objects
                            getParagraphTemplate(par, _templates);
                            getParagraphManuses(par, _manuses);

                            //sort paragraphs
                            sortedNumbersArray.sort(function (a, b) {
                                return a.order - b.order;
                            });
                            sortedNumbersArray.forEach(nrP => {
                                pageParagraphObjects[nrP.order] = nrP.paragraph;
                            });
                            }
                            //pageParagraphObjects.push(par);
                        }
                    })
                // }
                }
            }
        pageObj.paragraphObjects = pageParagraphObjects;
    });
  }
      


// WEBPACK FOOTER //
// ./src/utils/DataCombiner.js